import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { deleteVisite, setCurrentVisite } from './visitesSlice'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline'
import { EmptyValuePlaceholder, Textarea } from '@/components/ui'
import { formatDate } from '@/utils/formatters'
import { useDetailContext } from '@/components/DetailTemplate'

export default ({item}) => {
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)
  const dispatch = useDispatch()
  const detailContext = useDetailContext()

  const handleEditClick = () => {
    dispatch(setCurrentVisite(item))
    detailContext.setModalVisible(true)
  }

  const handleDeleteClick = () => {
    setShowConfirmDialog(true)
  }
  const confirmDelete = () => {
    dispatch(deleteVisite(item))
    setShowConfirmDialog(false)
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  return (
    <div className='group/item relative flex-col justify-center'>
      <div className='group-hover/item:bg-gray-300 p-2'>
        <div className='flex justify-start items-start'>
          <div className='flex space-x-2'>
            <p>
              Visite réalisée le <EmptyValuePlaceholder value={formatDate(item.date_visite)} />
            </p>
            { item.commentaires && (
              <div>
                <Textarea.Display value={item.commentaires} textareaClassName='min-h-0' />
              </div>
            )}
          </div>
          <div>
            <button 
              onClick={handleEditClick} 
              title="Modifier la visite"
              className="invisible group-hover/item:visible ml-1 p-1 btn btn-sm btn-ghost btn-square hover:bg-primary-400 w-[1.5rem]">
              <PencilSquareIcon />
            </button>
            <button 
              onClick={handleDeleteClick} 
              title="Supprimer la visite"
              className="invisible group-hover/item:visible ml-1 p-1 btn btn-sm btn-ghost btn-square hover:bg-primary-400 w-[1.5rem]">
              <TrashIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
  
      {showConfirmDialog && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Confirmer la suppression</h3>
            <p className="py-4">Êtes-vous sûr de vouloir supprimer cette visite ?</p>
            <div className="modal-action">
              <button onClick={confirmDelete} className="btn btn-secondary">Supprimer</button>
              <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
            </div>
          </div>
        </dialog>
      )}
    </div>
  )

}